var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      multiple: "",
      label: _vm.label,
      items: _vm.items,
      disabled: _vm.disabled,
      "item-disabled": "disabled",
      "item-text": _vm.itemText,
      "item-value": _vm.returnObject ? undefined : _vm.itemValue,
      "return-object": _vm.returnObject
    },
    scopedSlots: _vm._u([
      {
        key: "prepend-item",
        fn: function() {
          return [
            _c(
              "v-list-tile",
              { attrs: { ripple: "" }, on: { click: _vm.toggle } },
              [
                _c(
                  "v-list-tile-action",
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color:
                            _vm.selected.length > 0 ? "indigo darken-4" : ""
                        }
                      },
                      [_vm._v(_vm._s(_vm.icon))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-tile-content",
                  [
                    _c("v-list-tile-title", [
                      _vm._v(_vm._s(_vm.$t("selectAll")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "mt-2" })
          ]
        },
        proxy: true
      },
      {
        key: "selection",
        fn: function(ref) {
          var item = ref.item
          var index = ref.index
          return [
            index <= _vm.displayQty
              ? _c("v-chip", [_c("span", [_vm._v(_vm._s(item[_vm.chipText]))])])
              : _vm._e(),
            _vm._v(" "),
            index === _vm.displayQty + 1
              ? _c("span", { staticClass: "grey--text caption" }, [
                  _vm._v(
                    "(+" +
                      _vm._s(_vm.selected.length - 2) +
                      " " +
                      _vm._s(
                        _vm.selected.length - 2 > 1
                          ? _vm.$t("othersLower")
                          : _vm.$t("otherLower")
                      ) +
                      ")"
                  )
                ])
              : _vm._e()
          ]
        }
      }
    ]),
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58e03290", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58e03290","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectWidget.vue
// module id = null
// module chunks = 